(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("buildbot-www", [], factory);
	else if(typeof exports === 'object')
		exports["buildbot-www"] = factory();
	else
		root["buildbot-www"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 